var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterMeterSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#465165;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M300.4,152.2c-82.3,0-149.2,66.9-149.2,149.2s66.9,149.2,149.2,149.2,149.2-66.9,149.2-149.2-66.9-149.2-149.2-149.2Zm0,279.5c-71.8,0-130.2-58.4-130.2-130.2s58.4-130.2,130.2-130.2,130.2,58.4,130.2,130.2-58.4,130.2-130.2,130.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M386.4,233.2H213.7c-5.4,0-9.7,4.4-9.7,9.7v38.7c0,5.4,4.4,9.7,9.7,9.7h172.7c5.4,0,9.7-4.4,9.7-9.7v-38.7c0-5.4-4.4-9.7-9.7-9.7Zm-9.3,39.2H223v-20.2h154.1v20.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M580.4,206.7h-58.4c-5.4,0-9.7,4.4-9.7,9.7v9.6h-41.6c-28.7-65.9-94.4-112.2-170.8-112.2s-142.1,46.2-170.8,112.2h-41.4v-9.6c0-5.4-4.4-9.7-9.7-9.7H19.6c-5.4,0-9.7,4.4-9.7,9.7v169.6c0,5.4,4.4,9.7,9.7,9.7h58.4c5.4,0,9.7-4.4,9.7-9.7v-10h42.3c29.1,64.8,94.3,110.1,169.9,110.1s140.7-45.2,169.9-110.1h42.5v10c0,5.4,4.4,9.7,9.7,9.7h58.4c5.4,0,9.7-4.4,9.7-9.7V216.5c0-5.4-4.4-9.7-9.7-9.7ZM68.7,376.8H28.9V225.7h39.8v151Zm19-19.7v-112.1h34.4c-5.4,17.4-8.3,35.8-8.3,55s3.2,39.1,9,57.1h-35Zm212.2,110.1c-92.2,0-167.1-75-167.1-167.1s75-167.1,167.1-167.1,167.1,75,167.1,167.1-75,167.1-167.1,167.1Zm177.2-110.1c5.8-18,9-37.2,9-57.1s-2.9-37.6-8.3-55h34.5v112.1h-35.2Zm94,19.7h-39.8V225.7h39.8v151Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M357.8,328.5v-17.3h-18.4v17.1c-2.7,.8-5.2,2-7.5,3.5-13.9,9.1-17.9,27.7-8.8,41.6,9.1,13.9,27.7,17.9,41.6,8.8,13.9-9.1,17.9-27.7,8.8-41.6-3.7-5.7-9.2-10-15.7-12.1Zm-1.2,40.4h0c-6.8,4.6-16.1,2.7-20.6-4.1-4.6-6.8-2.7-16.1,4.1-20.6,6.8-4.6,16.1-2.7,20.6,4.1h0c4.6,6.8,2.7,16.1-4.1,20.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 204,
    y: 349.4,
    width: 20.3,
    height: 20.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 241.7,
    y: 349.4,
    width: 20.3,
    height: 20.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 279.3,
    y: 349.4,
    width: 20.3,
    height: 20.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 204,
    y: 311.1,
    width: 20.3,
    height: 20.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 241.7,
    y: 311.1,
    width: 20.3,
    height: 20.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 279.3,
    y: 311.1,
    width: 20.3,
    height: 20.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 252.1,
    y: 195.7,
    width: 20.3,
    height: 20.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 289.7,
    y: 195.7,
    width: 20.3,
    height: 20.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 327.3,
    y: 195.7,
    width: 20.3,
    height: 20.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeterSymbol);
export default __webpack_public_path__ + "static/media/water-meter-symbol.8661edc044d39d33e0f6397244cfdcbe.svg";
export { ForwardRef as ReactComponent };